import { Box, Divider, Grid, Card, CardContent, Typography, TextField, Autocomplete, RadioGroup, Radio, FormControlLabel, Button,Checkbox,useTheme  } from "@mui/material";
import React, { useState, useEffect } from "react";
import Header from "../../Layout/Header";
import { API_ENDPOINTS } from "../../config/api/apiCall";
import FetchDataFromApi, { callApi } from "../commonapicall/fetchdata";

import MasterAdminActionMenu from "./masterAdminMenu";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { tokens } from "../../theme/theme";

const ViewMasterAdmin = () => {
    const [activePage, setActivePage] = useState('ViewMainPage');
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const SetActive = (page) => {
        setActivePage(page);
    }

    const handleBackWinderMachineEntry = () => {
        setActivePage('ViewMainPage');

        
    }

    const CompanyListColumns = [
        // add option  button
        //edit button ,down arrow button, delete button
        {
            field: "actions",
            headerName: "Actions",
            flex: 1,
            renderCell: (params) => (
                <>
                    <EditIcon onClick={() => handleEdit(params.row.id)} style={{ cursor: 'pointer', marginRight: 5 }} />
                    <DeleteIcon onClick={() => handleDelete(params.row.id)} style={{ cursor: 'pointer', marginRight: 5 }} />
                    <MoreVertIcon style={{ cursor: 'pointer' }} />
                </>
            )
        }   ,
        { field: "id", headerName: "SNo", hide: true, flex: 1, cellClassName: "name-column--cell" },
        { field: "company_name", headerName: "Company Name", flex: 3, cellClassName: "name-column--cell" },
        { field: "unit", headerName: "Unit", flex: 1, cellClassName: "name-column--cell" },
        // { field: "addressline1", headerName: "Address Line1", flex: 3, cellClassName: "name-column--cell" },
        // { field: "addressline2", headerName: "Address Line2", flex: 3, cellClassName: "name-column--cell" },
        // { field: "addressline3", headerName: "Address Line3", flex: 3, cellClassName: "name-column--cell" },
        { field: "country", headerName: "Country", flex: 2, cellClassName: "name-column--cell" },
        // { field: "contact_person", headerName: "Contact Person", flex: 2, cellClassName: "name-column--cell" }, 
        { field: "phone", headerName: "Phone No.", flex: 2, cellClassName: "name-column--cell" },
        { field: "email", headerName: "Email", flex: 3, cellClassName: "name-column--cell" },
        { field: "mill_type", headerName: "Mill Type", flex: 2, cellClassName: "name-column--cell" },
        { field: "tpd", headerName: "TPD", flex: 1, cellClassName: "name-column--cell" },
        { field: "status", headerName: "Status", flex: 1, renderCell: (params) => <Checkbox size="small" checked={params.value} disabled /> },
        { field: "licence_from", headerName: "Licence From", flex: 2, cellClassName: "name-column--cell" },
        { field: "licence_to", headerName: "Licence To", flex: 2, cellClassName: "name-column--cell" },
        { field: "company_db_name", headerName: "Company DB Name", flex: 3, cellClassName: "name-column--cell" },
        { field: "subscription_model", headerName: "Subscription Model", flex: 3, cellClassName: "name-column--cell" },
        // { field: "is_db_shared", headerName: "Is DB Shared?", flex: 1, cellClassName: "name-column--cell" }, // checkbox value true ,false
        // { field: "trial_to_live", headerName: "Trial to Live", flex: 1, cellClassName: "name-column--cell" }, // checkbox value true ,false
        // { field: "created_on", headerName: "Created On", flex: 2, cellClassName: "name-column--cell" },
        // { field: "company_id", headerName: "Comapny ID", flex: 1, cellClassName: "name-column--cell" },
        // { field: "company_identifier", headerName: "Company Identifier", flex: 1, cellClassName: "name-column--cell" },     
        
    ];

    const handleEdit = (companyId) => {
        // Handle edit action
        console.log("Edit company with ID:", companyId);
    }

    const handleDelete = (companyId) => {
        // Handle delete action
        console.log("Delete company with ID:", companyId);
    }

    const sampleData = [
        { 
            id: 1,
            company_name: "ABC Company",
            unit: "Unit 1",
            addressline1: "123 Main St",
            addressline2: "Suite 100",
            addressline3: "",
            country: "USA",
            contact_person: "John Doe",
            phone: "123-456-7890",
            email: "john@example.com",
            mill_type: "Type A",
            tpd: 100,
            status: true,
            licence_from: "2024-01-01",
            licence_to: "2024-12-31",
            company_db_name: "ABC_DB",
            subscription_model: "Model X",
            is_db_shared: true,
            trial_to_live: false,
            created_on: "2024-05-01",
            company_id: "ABC001",
            company_identifier: "ABC123"
        },
        { 
            id: 2,
            company_name: "XYZ Corporation",
            unit: "Unit 2",
            addressline1: "456 Elm St",
            addressline2: "Suite 200",
            addressline3: "",
            country: "USA",
            contact_person: "Jane Smith",
            phone: "987-654-3210",
            email: "jane@example.com",
            mill_type: "Type B",
            tpd: 150,
            status: false,
            licence_from: "2024-02-01",
            licence_to: "2024-11-30",
            company_db_name: "XYZ_DB",
            subscription_model: "Model Y",
            is_db_shared: false,
            trial_to_live: true,
            created_on: "2024-05-02",
            company_id: "XYZ002",
            company_identifier: "XYZ456"
        },
        { 
            id: 3,
            company_name: "PQR Ltd.",
            unit: "Unit 3",
            addressline1: "789 Oak St",
            addressline2: "Suite 300",
            addressline3: "",
            country: "Canada",
            contact_person: "Alice Johnson",
            phone: "555-123-4567",
            email: "alice@example.com",
            mill_type: "Type C",
            tpd: 200,
            status: true,
            licence_from: "2024-03-01",
            licence_to: "2024-10-31",
            company_db_name: "PQR_DB",
            subscription_model: "Model Z",
            is_db_shared: false,
            trial_to_live: false,
            created_on: "2024-05-03",
            company_id: "PQR003",
            company_identifier: "PQR789"
        },
        // Add more rows to meet the minimum requirement of 10
    ];

    return (
        <Box>
            <Header title="Master Admin Settings" subtitle=""  />
            <Divider />
            <MasterAdminActionMenu  SetActive={SetActive}  />
            <Divider/>

            {/* Display Comapny List */}
            
            <Typography
          variant="h4"
          color={colors.grey[100]}
          fontWeight="bold"
          sx={{ m: "15px 0 5px 10px" }}
        >
          Company List
        </Typography>
            
                {/* <DataGrid
                    rows={sampleData}
                    columns={CompanyListColumns}
                    pageSize={5}
                    rowsPerPageOptions={[5, 10, 20]}
                    checkboxSelection
                /> */}

<Box

gridColumn="span 9"
gridRow={"span 2"}
alignItems="center"
justifyContent="center"
padding={1}
height="51vh"
sx={{

    "& .MuiCheckbox-root": {
        color: `${colors.greenAccent[200]} !important`,
    },
    "& .Muidropdown-root": {
        color: `${colors.greenAccent[200]} !important`,
    },

    borderLeft: "0", // Remove left border
    borderRight: "0", // Remove right border
}}
>
<DataGrid name="dgv-orderselection"  pageSize={5}
                    rowsPerPageOptions={[5, 10, 20]}
                   columnHeaderHeight={35} rowHeight={40} rows={sampleData} columns={CompanyListColumns}
// onRowSelectionModelChange={(ids) => {
//     const selectedIDs = new Set(ids);
//     //checkboxSelection
//     const selectedRows = orderList.filter((row) =>
//         selectedIDs.has(row.id),
//     );
//     setSelectedItems(selectedRows);


// }}

/>

</Box>
           
        </Box>
    );
};
export default ViewMasterAdmin;